import { render } from "./Depositions.vue?vue&type=template&id=5623fc1e&scoped=true"
import script from "./Depositions.vue?vue&type=script&lang=js"
export * from "./Depositions.vue?vue&type=script&lang=js"

import "./Depositions.vue?vue&type=style&index=0&id=5623fc1e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5623fc1e"]])

export default __exports__